const APP_CONFIG = {
  version: "7.91.1",
  title: "Claire V7.91.1",
  version_client: "7.91.1",
};

export default APP_CONFIG;
